import { render, staticRenderFns } from "./advertising-list.vue?vue&type=template&id=aa90f646&scoped=true"
import script from "./advertising-list.vue?vue&type=script&lang=js"
export * from "./advertising-list.vue?vue&type=script&lang=js"
import style0 from "./advertising-list.vue?vue&type=style&index=0&id=aa90f646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa90f646",
  null
  
)

export default component.exports